<template>
    <div>
        <div class="d-flex justify-content-center" v-if="loading">
            <b-spinner variant="secondary" type="grow"/>
        </div>
        <community-log-book
            v-else-if="communityData"
            :community-user-post="communityData.user_post"
            :community-posts="communityData.posts"
            :company-name="companyInfo.name"
            :user-id="userId"
            :question="customizedQuestion ? customizedQuestion : question"
            :miu-id="$route.params.elementId"
        />
    </div>
</template>

<script>
import CommunityLogBook from "../../../templates/CommunityLogBook";
import {mapGetters} from "vuex";

export default {
    name: "CollectiveRoomBlock",
    components: {CommunityLogBook},
    props:{
        question: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            loading: true,
            communityData: null,
            customizedQuestion: null
        }
    },
    mounted() {
        this.$axios.get(`/api/rest/community/miu/${this.$route.params.elementId}/room`)
            .then(res => {
                this.loading = false;
                this.communityData = res.data;
                this.customizedQuestion = res.data.altQuestion;
            })
            .catch(err => {
                this.loading = false;
                console.log(err);
            })
    },
    computed:{
        ...mapGetters({
            userId: 'user/getUserId',
            companyInfo: 'user/getCompanyInfo'
        })
    }
}
</script>